import {
  NgModule,
  makeEnvironmentProviders,
  EnvironmentProviders,
} from '@angular/core';
import { MapStyleService } from './map-style.service';

/** Or `importProvidersFrom(MapStyleServiceModule)` */
export function provideMapStyleService(): EnvironmentProviders {
  return makeEnvironmentProviders([MapStyleService]);
}

@NgModule({
  providers: [MapStyleService],
})
export class MapStyleServiceModule {}
